/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heroic_Awful_Maggot_GraspInputs */

const fr_heroic_awful_maggot_grasp = /** @type {(inputs: Heroic_Awful_Maggot_GraspInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'utilisateur a accès à tous les types d'événements disponibles.`)
};

/**

* @param {Heroic_Awful_Maggot_GraspInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const heroic_awful_maggot_grasp = /** @type {((inputs?: Heroic_Awful_Maggot_GraspInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heroic_Awful_Maggot_GraspInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_heroic_awful_maggot_grasp(inputs)
});